import type React from 'react';
import styled from 'styled-components';
import { Locale } from '@enmon/commons';
import { FormattedMessage } from '@/components/formatted_message/FormattedMessage';
import { Select } from '@/components/form';
import { LanguageMenu as messages } from './messages';
import { LOCALE_TRANSLATED } from '@/common/messages/locale';
import { useChangeLocale } from '@/containers/LanguageProvider/hooks/useChangeLocale';

const StyledSelect = styled(Select<Locale>)`
  && {
    background-color: transparent;
    border: none !important;
    box-shadow: none !important;

    .ant-select-content,
    .ant-select-selection-item {
      color: ${({ theme }) => theme.color.grey.white} !important;
      padding-right: 0 !important;
    }

    .ant-select-suffix {
      display: none;
    }
  }
`;

export const LanguageMenu: React.FC = () => {
  const { locale, changeLocale } = useChangeLocale();

  const options = [
    {
      label: <FormattedMessage {...messages.title} />,
      options: Object.values(Locale).map(loc => ({
        value: loc,
        label: <FormattedMessage {...LOCALE_TRANSLATED[loc]} />,
        'data-cy': `${loc}-option`,
        'data-test': `${loc}-option`,
      })),
    },
  ];

  return (
    <StyledSelect
      value={locale}
      onChange={changeLocale}
      variant="borderless"
      options={options}
      data-cy="language-menu"
      data-test="language-menu"
      popupMatchSelectWidth={false}
    />
  );
};
